import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useMemo } from "react";
import {
  faLongArrowAltDown,
  faLongArrowAltUp,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { evidenceColumnDisplayTitle } from "./Helpers";
import { EvidenceColumn, EvidenceColumnGroup, EvidenceType } from "../../../../../../store/onboarding/types";
import { Sorting } from "../EvidenceTable";

type OwnProps = {
  sortingDirection?: "asc" | "desc" | undefined;
  evidenceColumn: EvidenceColumn;
  evidenceColumnGroup: EvidenceColumnGroup;
  onEvidenceSort: any;
  sorting: Sorting;
  isReadonly?: boolean;
};

type Props = OwnProps;

const MeasurementLabelTooltip: React.FunctionComponent<Props> = ({
  sortingDirection,
  evidenceColumn,
  evidenceColumnGroup,
  onEvidenceSort,
  sorting,
  isReadonly
}) => {
  const columnName = evidenceColumn.measurement
    ? evidenceColumn.measurement?.column_name
    : undefined;

  const name = useMemo(() => evidenceColumnDisplayTitle(evidenceColumn), [
    evidenceColumn,
  ]);

  const displayedName = columnName ? columnName : name;
  const isBehaviorScreener = useMemo(() => {
    return evidenceColumn.evidence_type == EvidenceType.BehaviorScreener
  },[evidenceColumn])

  return (
    !isBehaviorScreener && !isReadonly ? 
      <OverlayTrigger
        overlay={
          <Tooltip id="fullName" className="customInfoTooltip">
            {evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp 
            || evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo 
            || evidenceColumn.evidence_type === EvidenceType.NeedAreas 
            ? null : name}
            {evidenceColumn.evidence_type === EvidenceType.Data ? <br /> : null}
            <small>
              {evidenceColumn.evidence_type === EvidenceType.Data && (
                `Click to View Benchmarks or Sort`
              )}
              {(evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp ||
                evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo ||
                evidenceColumn.evidence_type === EvidenceType.NeedAreas) && (
                evidenceColumn.evidence_type === sorting.evidenceType
                  ? (sorting.sortingCount < 1 || sorting.sortingCount >= 2
                      ? `Click to reset`
                      : 'Click to sort')
                  : 'Click to sort'
              )}
            </small>
          </Tooltip>
        }
      >
        <span onClick={
           evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp 
          ||evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo 
          || evidenceColumn.evidence_type === EvidenceType.NeedAreas
          ? onEvidenceSort(evidenceColumn, evidenceColumnGroup): () => "void(0)"
          } className={`${isReadonly ? 'data-period-dropdown-default':'data-period-dropdown-pointer'}`}>
          {sortingDirection !== undefined ? (
            <FontAwesomeIcon
              icon={
                (sortingDirection === "asc") && (sorting.column == evidenceColumn?.measurement?.column_name) ? faLongArrowAltUp : faLongArrowAltDown
              }
              className="mr-1"
            />
          ) : ''}
          {displayedName}
        </span>
      </OverlayTrigger>
    :
      <span title={(evidenceColumn.evidence_type === EvidenceType.Data) ? name : ''} onClick={
         ( evidenceColumn.evidence_type === EvidenceType.DiagnosticFollowUp 
          || evidenceColumn.evidence_type === EvidenceType.DiagnosticInfo 
          || evidenceColumn.evidence_type === EvidenceType.NeedAreas) && !isReadonly
          ? onEvidenceSort(evidenceColumn, evidenceColumnGroup): () => "void(0)"
          } className={`${isReadonly ? 'data-period-dropdown-default':'data-period-dropdown-pointer'}`}>
        {sortingDirection && !isReadonly && (
          <FontAwesomeIcon
            icon={
              (sortingDirection === "asc") 
              && (sorting.column == evidenceColumn?.measurement?.column_name) ? faLongArrowAltUp : faLongArrowAltDown
            }
            className="mr-1"
          />
        )}
        {displayedName}
      </span>
  );
};

export default MeasurementLabelTooltip;
